<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Código da Habilidade"
              v-model="form.filters.codigo"
              outlined
              dense
              maxlength="25"
              v-transform-case
              @keyup.enter="buscarHabilidades"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="Habilidade"
              v-model="form.filters.nome"
              outlined
              maxlength="25"
              dense
              @keyup.enter="buscarHabilidades"
            ></v-text-field>
          </v-col>
          <sca-select-ativo
            :cols="3"
            :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
            v-model="form.filters.ativo"
            @enter="buscarHabilidades"
          ></sca-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarHabilidades()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></sca-tooltip>
            <sca-tooltip
              :text="'Incluir'"
              :icon="'mdi-plus'"
              @click="openDialogManterHabilidade()"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        :no-data-text="table.noDataText"
      >
        <template v-slot:[`item.codigo`]="{ item }">
          <span>{{ item.codigo?.toUpperCase() }}</span>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="blue-grey lighten-5">
            <p class="ml-4 my-0 text-wrap mx-70vw">
              {{ item.descricao }}
            </p>
          </td>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.ativo" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sca-tooltip
            :text="'Visualizar'"
            :icon="'mdi-eye-outline'"
            :small="true"
            @click="openDialogVisualizarHabilidade(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="'Editar'"
            :icon="'mdi-pencil'"
            :small="true"
            @click="openDialogManterHabilidade(item)"
          ></sca-tooltip>
          <sca-tooltip
            :text="`${item.situacao ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.situacao ? 'mdi-toggle-switch-off' : 'mdi-toggle-switch'}`"
            :small="true"
            @click="inativarAtivarHabilidade(item)"
          ></sca-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarHabilidadeDialog
      :visible="dialogManterHabilidade.visible"
      :content="dialogManterHabilidade.content"
      :edit="dialogManterHabilidade.edit"
      @onClose="dialogManterHabilidade.close()"
      @onSave="buscarHabilidades()"
    ></CadastrarEditarHabilidadeDialog>
    <VisualizarHabilidadeDialog
      v-if="dialogVisualizarHabilidade.visible"
      :visible="dialogVisualizarHabilidade.visible"
      :content="dialogVisualizarHabilidade.content"
      @onClose="dialogVisualizarHabilidade.close()"
    ></VisualizarHabilidadeDialog>
  </div>
</template>

<script>
import { Dialog } from '~/commons/classes/dialog';
import { Habilidade } from '~/commons/classes/habilidade';
import HabilidadeService from '~/services/habilidade.service';
import datatablesMixin from '~/mixins/datatables.mixin';
import CadastrarEditarHabilidadeDialog from "./dialogs/CadastrarEditarHabilidadeDialog.vue";
import VisualizarHabilidadeDialog from "./dialogs/VisualizarHabilidadeDialog.vue";

export default {
  name: "ManterHabilidadesView",
  mixins: [HabilidadeService, datatablesMixin],
  components: {
    CadastrarEditarHabilidadeDialog,
    VisualizarHabilidadeDialog,
  },
  data: () => ({
    dialogManterHabilidade: Dialog.Build(),
    dialogVisualizarHabilidade: Dialog.Build(),
    form: {
      filters: {
        nome: null,
        codigo: null,
        ativo: null,
      },
    },
    table: {
      headers: [
        { text: 'Habilidade', align: 'center', value: 'nome' },
        { text: 'Código da Habilidade', align: 'center', value: 'codigo' },
        { text: 'O que será avaliado', align: 'center', value: 'data-table-expand' },
        { text: 'Situação', align: 'center', value: 'situacao', sortable: false },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ],
      itens: [],
      noDataText: '',
    },
  }),
  methods: {
    iniciarMensagemDeNenhumRegistroEncontrado() {
      this.table.noDataText = this.$possuiPermissao('habilidade.listar')
        ? ''
        : 'Não há registros a serem exibidos';
    },
    buscarHabilidades() {
      this.table.noDataText = 'Não há registros a serem exibidos';
      this.$buscarHabilidades({ params: this.form.filters }).then(({ data }) => (this.table.itens = data.itens));
    },
    openDialogManterHabilidade(habilidade) {
      habilidade
        ? this.$visualizarHabilidades(habilidade).then(
          ({ data }) => this.dialogManterHabilidade.open(new Habilidade(data.resposta), true))
        : this.dialogManterHabilidade.open(Habilidade.Build());
    },
    openDialogVisualizarHabilidade(habilidade) {
      this.$visualizarHabilidades(habilidade).then(
        ({ data }) => this.dialogVisualizarHabilidade.open(new Habilidade(data.resposta)));
    },
    inativarAtivarHabilidade(habilidade) {
      this.$swal({
        text: `Deseja ${habilidade.ativo ? "inativar" : "ativar"} o registro?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$inativarAtivarHabilidade(habilidade.id).then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarHabilidades();
        });
      });
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.form.filters.ativo = null;
    },
  },
  mounted() {
    this.iniciarMensagemDeNenhumRegistroEncontrado();
  }
};
</script>
